export default __webpack_public_path__ + "static/media/check-active.cbf316dd.svg";